import request from 'store/utils/request';

export const loginUserRequest = async data => {
  try {
    return await request.post('/auth/login/', data);
  } catch (error) {
    throw error;
  }
};

export const getUserRequest = async () => {
  try {
    return await request.get('/auth/me/');
  } catch (error) {
    throw error;
  }
};

export const tokenIntrospectionRequest = async token => {
  try {
    return await request.get('/auth/me/', {
      headers: { Authorization: `Token ${token}` },
    });
  } catch (error) {
    throw error;
  }
};

export const pairAccount = async data => request.post('/auth/pair/', data);

export const logoutUserRequest = async () => {
  try {
    return await request.post('/auth/logout/');
  } catch (error) {
    throw error;
  }
};

export const forgotPasswordRequest = async data => {
  try {
    return await request.post('/auth/forgot/', data);
  } catch (error) {
    throw error;
  }
};

export const resetPasswordRequest = async data => {
  try {
    return await request.post('/auth/password_reset/', data);
  } catch (error) {
    throw error;
  }
};

export const updateUserRequest = async data => {
  try {
    return await request.put('/auth/me/', data);
  } catch (error) {
    throw error;
  }
};

export const updatePasswordRequest = async data => {
  try {
    return await request.post('/auth/password/', data);
  } catch (error) {
    throw error;
  }
};

export const updateAvatarRequest = async ({ avatar }) => {
  try {
    const data = new FormData();
    data.append('avatar', avatar, avatar.name);

    return await request.post('/auth/avatar/', data, {
      headers: {
        'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
      },
    });
  } catch (error) {
    throw error;
  }
};
